module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }